import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge 에 Glow 커스텀 토큰을 알려준다. 알려주지 않으면 text-body 를 색상으로 오인해
 * text-white 같은 색상 클래스를 지워 버린다.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['display', 'h1', 'h2', 'h3', 'body', 'caption', 'label'],
      shadow: ['glow'],
      container: ['app'],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
